export function getByteSize(str: string): number {
	return new TextEncoder().encode(str).length
}

export function addComma(num: number | string): string {
	if (num === null || num === undefined) return ""
	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isString = (value: string | any) => {
	return typeof value === "string" || value instanceof String
}
